<template>
    <v-container>
        <v-layout row wrap>
            <v-flex xs12>
                <v-card>
                    <v-card-title class="headline">Terminos de Privacidad</v-card-title>
                    <v-card-text>
                        <h2>Introducción</h2>
                        <p>La privacidad de los usuarios es importante para Finishtime ("nosotros" o "nuestra
                            organización"). Estos Términos de Privacidad explican cómo recopilamos, usamos, almacenamos
                            y protegemos los datos personales de los usuarios de nuestra aplicación móvil y sitio web de
                            inscripción a eventos.</p>
                        <p>Al utilizar nuestros servicios, usted acepta las prácticas descritas en esta política. Si no
                            está de acuerdo, no debe usar la aplicación ni el sitio web.</p>

                        <h2>Información que recopilamos</h2>
                        <p>Podemos recopilar los siguientes tipos de información:</p>
                        <ol>
                            <li>
                                <strong>Información personal proporcionada por el usuario:</strong>
                                <ul>
                                    <li>Nombre completo.</li>
                                    <li>Fecha de nacimiento.</li>
                                    <li>Número de documento.</li>
                                    <li>Dirección de correo electrónico.</li>
                                    <li>Número de teléfono.</li>
                                    <li>Dirección postal.</li>
                                </ul>
                            </li>
                            <li>
                                <strong>Información recopilada automáticamente:</strong>
                                <ul>
                                    <li>Dirección IP.</li>
                                    <li>Tipo de dispositivo y sistema operativo.</li>
                                    <li>Datos de uso, como páginas visitadas y tiempo de navegación.</li>
                                </ul>
                            </li>
                            <li>
                                <strong>Datos relacionados con eventos:</strong>
                                <ul>
                                    <li>Información sobre los eventos a los que se inscribe.</li>
                                    <li>Preferencias de participación o intereses declarados.</li>
                                </ul>
                            </li>
                        </ol>

                        <h2>Cómo utilizamos su información</h2>
                        <p>Utilizamos la información recopilada para:</p>
                        <ul>
                            <li>Proveer los servicios de inscripción a eventos.</li>
                            <li>Enviar confirmaciones y recordatorios de eventos.</li>
                            <li>Gestionar pagos y facturación, si corresponde.</li>
                            <li>Mejorar la funcionalidad y seguridad de nuestra aplicación y sitio web.</li>
                            <li>Realizar análisis estadísticos sobre el uso de nuestros servicios.</li>
                            <li>Enviar comunicaciones promocionales relacionadas con eventos, con su consentimiento
                                previo.</li>
                            <li>Enviar emails promocionales de eventos publicados en nuestro sitio.</li>
                            <li>Exportacion de datos basicos como Nombre completo, fecha de nacimiento y edad, que se proporcionan a empresas encargadas de la clasificación.</li>
                        </ul>

                        <h2>Compartir su información</h2>
                        <p>Nos comprometemos a no vender ni alquilar sus datos personales. Sin embargo, podríamos
                            compartir su información con terceros en las siguientes situaciones:</p>
                        <ul>
                            <li><strong>Proveedores de servicios:</strong> Empresas que nos ayudan con el alojamiento,
                                procesamiento de pagos, envío de correos electrónicos u otras funciones operativas.</li>
                            <li><strong>Requerimientos legales:</strong> Si es necesario para cumplir con leyes,
                                regulaciones o procesos legales.</li>
                            <li><strong>Consentimiento del usuario:</strong> Si usted autoriza compartir su información
                                para un propósito específico.</li>
                        </ul>

                        <h2>Almacenamiento y seguridad de los datos</h2>
                        <p>Implementamos medidas de seguridad técnicas y organizativas para proteger su información
                            contra accesos no autorizados, pérdida, alteración o divulgación. Sus datos se almacenan en
                            servidores seguros ubicados en Virginia, USA.</p>

                        <h2>Derechos del usuario</h2>
                        <p>De acuerdo con la Ley de Protección de Datos Personales de Argentina (Ley 25.326), usted
                            tiene derecho a:</p>
                        <ul>
                            <li>Acceder a sus datos personales.</li>
                            <li>Solicitar la actualización o corrección de información incorrecta.</li>
                            <li>Solicitar la eliminación de sus datos personales, salvo que debamos conservarlos por
                                motivos legales.</li>
                        </ul>
                        <p>Para ejercer estos derechos, puede contactarnos en <a
                                href="mailto:finishtimechivilcoy@gmail.com">finishtimechivilcoy@gmail.com</a>.</p>

                        <h2>Uso de cookies y tecnologías similares</h2>
                        <p>Nuestro sitio web y aplicación utilizan cookies para mejorar la experiencia del usuario.
                            Estas cookies permiten funcionalidades como recordar sus preferencias y analizar el uso del
                            servicio. Puede deshabilitar las cookies en la configuración de su navegador.</p>

                        <h2>Cambios en los Términos de Privacidad</h2>
                        <p>Nos reservamos el derecho de actualizar esta política de privacidad en cualquier momento.
                            Notificaremos a los usuarios sobre cambios significativos mediante un aviso en nuestra
                            aplicación o sitio web.</p>

                        <h2>Contacto</h2>
                        <p>Si tiene preguntas o inquietudes sobre nuestra política de privacidad, puede contactarnos en:
                        </p>
                        <ul>
                            <li><strong>Correo electrónico:</strong> <a
                                    href="mailto:finishtimechivilcoy@gmail.com">finishtimechivilcoy@gmail.com</a>.</li>
                            <li><strong>Teléfono:</strong> 2346654774.</li>
                        </ul>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: 'PrivacyPolicy'
}
</script>

<style scoped>
.headline {
    font-weight: bold;
}
</style>